import * as React from 'react';

import { GMetrixUpload } from 'components/GMetrixUpload/GMetrixUpload';
import { WhiteLabel } from 'pages/partners/site_branding/interfaces';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, FormLabel, Row } from 'react-bootstrap';
import { SketchPicker } from 'react-color';

import { RichTextEditor } from './RichTextEditor';

export const WhiteLabelForm: React.FC<{
    onStatusChange: (event: any, typeOfIcon: string) => void;
    partnerId: number;
    selectedWhiteLabelObj: WhiteLabel;
    setSelectedWhiteLabelObj: (whiteLabel: WhiteLabel) => void;
}> = ({ onStatusChange, partnerId, selectedWhiteLabelObj, setSelectedWhiteLabelObj }) => {

    const { formatMessage } = useIntl();

    return (
        <>
            <Row className="d-flex mb-4">
                <Col>
                    <GMetrixInput
                        className="me-2"
                        label={formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' })}
                        onChange={e => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Name: e.target.value })}
                        type="email"
                        value={selectedWhiteLabelObj.Name}
                    />
                </Col>
                <Col>
                    <GMetrixInput
                        className="me-2"
                        label={formatMessage({ id: 'subdomain.7bc07d11', defaultMessage: 'Subdomain' })}
                        onChange={e => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Subdomain: e.target.value })}
                        type="email"
                        value={selectedWhiteLabelObj.Subdomain}
                    />
                </Col>
                <Col>

                    <GMetrixInput
                        className="me-2"
                        label={formatMessage({ id: 'description.e1c24171', defaultMessage: 'Description', description: 'Formulario' })}
                        onChange={e => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Description: e.target.value })}
                        type="email"
                        value={selectedWhiteLabelObj.Description}
                    />
                </Col>

            </Row>
            <Row className="d-flex mb-4">
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Primary Icon" id="primary_icon.d50d3617" />
                    </FormLabel>
                    <div className="icon-wrapper">
                        <img className="m-2 image-size" src={selectedWhiteLabelObj.PrimaryIcon} />
                    </div>
                    <GMetrixUpload
                        onBeforeUpload={e => {

                            e.additionalData.partnerId = partnerId;

                        }}
                        restrictions={{
                            allowedExtensions: ['.gif', '.jpg', '.png', '.svg'],
                            maxFileSize: 10485760
                        }}
                        multiple={false}
                        onStatusChange={e => onStatusChange(e, 'primaryIcon')}
                        saveUrl={'/Api/SiteBranding/UploadSiteBrandingIcon'}
                        withCredentials={false}
                    />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Secondary Icon" id="secondary_icon.6973a8a6" />
                    </FormLabel>
                    <div className="icon-wrapper">
                        <img className="m-2 image-size" src={selectedWhiteLabelObj.SecondaryIcon} />
                    </div>
                    <GMetrixUpload
                        onBeforeUpload={e => {

                            e.additionalData.partnerId = partnerId;

                        }}
                        restrictions={{
                            allowedExtensions: ['.gif', '.jpg', '.png', '.svg'],
                            maxFileSize: 10485760
                        }}
                        multiple={false}
                        onStatusChange={e => onStatusChange(e, 'secondaryIcon')}
                        saveUrl={'/Api/SiteBranding/UploadSiteBrandingIcon'}
                        withCredentials={false}
                    />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Background Image" id="background_image.b480eb44" />
                    </FormLabel>
                    <div className="icon-wrapper">
                        <img className="m-2 image-size" src={selectedWhiteLabelObj.BackgroundImage} />
                    </div>
                    <GMetrixUpload
                        onBeforeUpload={e => {

                            e.additionalData.partnerId = partnerId;

                        }}
                        restrictions={{
                            allowedExtensions: ['.gif', '.jpg', '.png', '.svg'],
                            maxFileSize: 10485760
                        }}
                        multiple={false}
                        onStatusChange={e => onStatusChange(e, 'backgroundImage')}
                        saveUrl={'/Api/SiteBranding/UploadSiteBrandingIcon'}
                        withCredentials={false}
                    />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Login BackgroundImage" id="login_backgroundimage.ff928e64" />
                    </FormLabel>
                    <div className="icon-wrapper">
                        <img className="m-2 image-size" src={selectedWhiteLabelObj.LoginBackgroundImage} />
                    </div>
                    <GMetrixUpload
                        onBeforeUpload={e => {

                            e.additionalData.partnerId = partnerId;

                        }}
                        restrictions={{
                            allowedExtensions: ['.gif', '.jpg', '.png', '.svg'],
                            maxFileSize: 10485760
                        }}
                        multiple={false}
                        onStatusChange={e => onStatusChange(e, 'loginBackgroundImage')}
                        saveUrl={'/Api/SiteBranding/UploadSiteBrandingIcon'}
                        withCredentials={false}
                    />
                </Col>
            </Row>
            <Row className="d-flex mb-4">
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Primary Color" id="primary_color.9cc0fa0f" />
                    </FormLabel>
                    <SketchPicker color={selectedWhiteLabelObj.Color1} onChangeComplete={(e: any) => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Color1: e.hex })} />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Secondary Color" id="secondary_color.12f708fd" />
                    </FormLabel>
                    <SketchPicker color={selectedWhiteLabelObj.Color2} onChangeComplete={(e: any) => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Color2: e.hex })} />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Tertiary Color" id="tertiary_color.55dfa1d6" />
                    </FormLabel>
                    <SketchPicker color={selectedWhiteLabelObj.Color3} onChangeComplete={(e: any) => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, Color3: e.hex })} />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Background Color" id="background_color.cc536d23" />
                    </FormLabel>
                    <SketchPicker color={selectedWhiteLabelObj.BackgroundColor} onChangeComplete={(e: any) => setSelectedWhiteLabelObj({ ...selectedWhiteLabelObj, BackgroundColor: e.hex })} />
                </Col>
            </Row>

            <Row className="mb-4">
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="Support Info" id="support_info.610d152f" />
                    </FormLabel>
                    <RichTextEditor content={'supportString'} selectedWhiteLabelObj={selectedWhiteLabelObj} setContent={setSelectedWhiteLabelObj} value={selectedWhiteLabelObj.SupportString} />
                </Col>
                <Col>
                    <FormLabel className="mb-2 fw-bold">
                        <FormattedMessage defaultMessage="School Policy" id="school_policy.31ef9a62" />
                    </FormLabel>
                    <RichTextEditor content={'policy'} selectedWhiteLabelObj={selectedWhiteLabelObj} setContent={setSelectedWhiteLabelObj} value={selectedWhiteLabelObj.Policy} />
                </Col>
            </Row>
        </>
    );

};
